import { useContext } from 'react';
import { DeletePayoutProfileModalContext } from './DeletePayoutProfileModalContext';

export const useDeletePayoutProfileModal = () => useContext(DeletePayoutProfileModalContext);
